// extracted by mini-css-extract-plugin
module.exports = {"layout":"question-ask-view_layout__3g9-S","container":"question-ask-view_container__3iXN1","topForm":"question-ask-view_topForm__tm_f1"};